import FormattedAddress from "components/Atoms/FormattedAddress";
import { PhosphorPencilButton, PhosphorTrashButton } from "components/Atoms/PhosphorIconButton";
import LinkedShowsList from "components/LinkedShows/LinkedShowsList";
import React from "react";
import { formatTime, formatWrittenDayMonthYear } from "utilities";
interface Props {
  train: server.dto.LegacyTrain
  segment: server.dto.LegacyTrainSegment
  onEditClicked: (segment: server.dto.LegacyTrainSegment) => void
  onDeleteClicked: (segment: server.dto.LegacyTrainSegment) => void
}

const SegmentDetail = (props: Props) => {
  const { segment, train } = props;

  const endDateTime = (segment.start.dateTimeLocal !== segment.end.dateTimeLocal)
    ? `${formatWrittenDayMonthYear(segment.end.dateTimeLocal)} ${formatTime(segment.end.dateTimeLocal)}`
    : formatTime(segment.end.dateTimeLocal);

  return <div className="train-row-card flex-column">
    <div className="margin-bottom padding-bottom-large flex border-bottom gap">
      <div className="grow1">
        <div className="table-main-link">{RESX.Train.resxTrain} {segment.trainNumber} : {segment.title}</div>
      </div>

      {train.permissions.canDelete && <PhosphorTrashButton
        layout="in-square"
        onClick={() => props.onDeleteClicked(props.segment)} />}

      {train.permissions.canModify && <PhosphorPencilButton
        layout="in-square"
        onClick={() => { props.onEditClicked(props.segment); }}
      />}
    </div>

    <div className="flex gap">
      <div style={{ flexBasis: 400 }}>
        <div className="flex margin-bottom-large gap">
          <div className="grow1 big_text">{formatWrittenDayMonthYear(segment.start.dateTimeLocal)}</div>
          <div className="big_text">{formatTime(segment.start.dateTimeLocal)}</div>
          <div>
            <i className="icon-arrow-right small"></i>
          </div>
        </div>
        <div>{segment.start.station.name}</div>
        <div className="s1_gray">
          <FormattedAddress address={segment.start.station.address} />
          {segment.start.platform && <div>{RESX.Train.Platform} {segment.start.platform}</div>}
        </div>
      </div>
      <div>
        <div className="big_text margin-bottom-large">{endDateTime}</div>
        <div>{segment.end.station.name}</div>
        <div className="s1_gray">
          <FormattedAddress address={segment.end.station.address} />
          {segment.end.platform && <div>{RESX.Train.Platform} {segment.end.platform}</div>}
        </div>
      </div>
    </div>

    <table className="s1_table clean rowspace-small margin-top padding-top-large border-top">
      <tbody>
        {segment.carriage && <tr>
          <td>{RESX.Train.Carriage}</td>
          <td>{segment.carriage}</td>
        </tr>}

        {segment.seats && <tr>
          <td>{RESX.Flight.Seats}</td>
          <td>{segment.seats}</td>
        </tr>}

        {segment.travelClass.value !== "unknown" && <tr>
          <td>{RESX.Flight.TravelClass}</td>
          <td>{segment.travelClass.text}</td>
        </tr>}

        {segment.linkedShows.length > 0 && <tr>
          <td>{RESX.GeneralLabels.LinkedTo}</td>
          <td>
            <LinkedShowsList onChange={() => { }} shows={segment.linkedShows} />
          </td>
        </tr>}
      </tbody>
    </table>
  </div>;
};

export default SegmentDetail;